















import Vue from "vue";

import IconClose from "@/components/icons/IconClose.vue";

export default Vue.extend({
  name: "modal-close-button",
  components: { IconClose },
});
